import {
  Box,
  Button,
  Container,
  CssBaseline,
  Typography
} from "@material-ui/core"
import Page from "./Page"

interface MessagePageProps {
  title: string
  subTitle?: string
  actionLabel?: string
  onAction?: () => void
}

const MessagePage: React.FC<MessagePageProps> = ({
  title,
  subTitle = null,
  actionLabel,
  onAction
}) => {
  return (
    <Page title={title}>
      <CssBaseline />
      <Container>
        <Box py={3}>
          <Typography variant="h1">{title}</Typography>
          {subTitle ? (
            <Typography variant="subtitle2">{subTitle}</Typography>
          ) : null}
          {actionLabel && onAction ? (
            <Box mt={2}>
              <Button color="primary" variant="contained" onClick={onAction}>
                {actionLabel}
              </Button>
            </Box>
          ) : null}
        </Box>
      </Container>
    </Page>
  )
}

export default MessagePage
